/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ChatMessage = {
    id: string;
    threadId: string;
    role: ChatMessage.role;
    content: string;
    createdAt: string;
    updatedAt: string;
};

export namespace ChatMessage {

    export enum role {
        USER = 'user',
        ASSISTANT = 'assistant',
        TOOL_CALL = 'tool_call',
    }


}

